import { useState, useEffect, useRef, useCallback } from "react";
import { useHistory } from 'react-router-dom';

import Grid from '@material-ui/core/Grid';
import ModeEditIcon from '@material-ui/icons/EditOutlined';
import AttachIcon from '@material-ui/icons/AttachFile';
import CardIcon from '@material-ui/icons/LibraryBooks';

import Table from '@base/Table';
import Dialog from "@base/Dialog";
import File from "@base/Inputs/File";
import Toast from '@base/Toast';

import escolaService from "@services/EscolaService";

export const OutrosDocumentosTableView = (props) => {
	const processo = props.processo;
	const escola = props.escola;

	const [openDialogUploadDE, setOpenDialogUploadDE] = useState(false);
	const [documentosTableData, setDocumentosTableData] = useState([]);
	const [origemSelecionada, setOrigemSelecionada] = useState();

	const toastRef = useRef(null);

	const carregarDados = useCallback(() => {
		escolaService.listarPorCodigoInepOuEticket(processo, escola.codigoInep)
			.then(esc => setDocumentosTableData(esc.data.documentos));
	}, [escola, processo]);

	useEffect(() => {
		setDocumentosTableData(escola.documentos);
	}, [escola, processo]);

	let history = useHistory();

	const columnsDocumentos = [
		{ label: 'Origem', name: 'origem', func: null, key: true, ordering: false },
		{ label: 'Nome', name: 'nomeDocumento', func: null, key: true, ordering: false },
		{ label: 'Digitalizado', name: 'dataDigitalizacao', func: (obj) => obj ? 'Sim' : 'Não', key: false, ordering: false },
		{ label: 'Digitado', name: 'dataDigitacao', func: (obj) => obj ? 'Sim' : 'Não', key: false, ordering: false }
	];

	function redirecionarParaPaginaDe(id) {
		history.push({
			pathname: `/${processo}/escola/${escola.codigoInep}/de/${id}`,
			state: { codigoInep: escola.codigoInep }
		});
	}

	function downloadArquivo(tipo,origem) {

		escolaService.downloadDE(processo, escola.codigoInep,origem).then(resultado => {
				const file = resultado.data.type.includes('image') ? resultado.data : new Blob([resultado.data], { type: resultado.data.type });
				const fileURL = URL.createObjectURL(file);
				window.open(fileURL, '_blank');
		}).catch(erro => {
			toastRef.current.show("error","Não foi posível fazer download do arquivo.");
		});
	}

	const actionsDocumentos = [
		{
			name: () => "Editar",
			func: (id,obj) => {
					redirecionarParaPaginaDe(id.origem);
			}, icon: <ModeEditIcon />,
			disabled: () => false
		},
		{
			func: (id) => {
				downloadArquivo(id.nomeDocumento,id.origem);
			} ,
			icon: <CardIcon />,
			disabled: (id,obj) => obj.dataDigitalizacao ? false : true,
			name: (id,obj) => obj.dataDigitalizacao ? "Visualizar Digitalização" : "Não existe arquivo digitalizado."
		},
		{
			name: () => "Anexar Digitalização",
			func: (id) => {
				setOrigemSelecionada(id.origem);
					setOpenDialogUploadDE(true);
			},
			icon: <AttachIcon />,
			disabled: () => false
		}
	];

	return (

		<>
			<Toast ref={toastRef} />
			<br/>

			<Grid container spacing={5}>
				<Grid item xs={12}>
					<Table style={{ marginTop: 0 }}
						columns={columnsDocumentos}
						tableData={documentosTableData}
						actions={actionsDocumentos}
						loading={false}
					/>
				</Grid>
			</Grid>

			<Dialog
				maxWidth={"sm"}
				fullWidth={true}
				closeDialog={() => setOpenDialogUploadDE(false)}
				openDialog={openDialogUploadDE}
				title={"Anexar Documento de Envio"}
				actions={[]}
			>

				<File handleUpload={(arquivo) => {
						const config = { headers: { 'content-type': 'multipart/form-data' } }
						const file = new FormData();

						file.append('nmArquivo', arquivo.name)
						file.append('tipoArquivo', arquivo.type)
						file.append('descricao', arquivo.description)
						file.append('arquivo', arquivo)
						file.append('processo', processo);
						file.append('escola', escola.codigoInep);

						escolaService.uploadDE(processo, escola.codigoInep, origemSelecionada, file, config)
							.then(resultado => {
								setOpenDialogUploadDE(false);
								carregarDados();
								toastRef.current.show("success", "Digitalização do de recebida com sucesso!");
						}).catch(resultado => {
							toastRef.current.show("error","Não foi posível fazer upload do arquivo.");
						});
					}
				}/>
			</Dialog>

		</>
	);
}

export default OutrosDocumentosTableView;
